import { errorHandler } from '@/services/toastHandler'

export default {
  namespaced: true,

  state: {
    loading: false,
    error: '',
  },

  mutations: {
    LOADING: s => {
      s.loading = true
      s.error = ''
    },
    SET_ERROR: (s, error) => (s.error = error),
    LOADED: s => (s.loading = false),
  },

  actions: {
    async verifyUser({ commit }, payload) {
      commit('LOADING')
      try {
        const { isVerified, id } = payload
        const { data: response } = await this.$api.put(`/portal/users/${id}/verify-status`, {
          isVerified,
        })
        // const { data: response } = await this.$api.put(`/portal/users/${id}/verify-status`)
        return response.data
      } catch (e) {
        const error = e || 'Error verifying user!'
        errorHandler(error)
        // return e.response.data.error.code
      } finally {
        commit('LOADED')
      }
    },
  },
}
